import { IstepOptionCustom } from "../components/tour-step/tour-step-option";

export const configInitSteps = {
  disablePageScrolling: true,
  scrollContainer: '.app__content',
  backdropConfig: { offset: 8, zIndex: '999' },
};

export const stepsTour: IstepOptionCustom[] = [
  // AÇÕES DE VERSOES
  {
    anchorId: 'status-btn', 
    title: 'Status', 
    content: "Esta função permite alterar o status do negócio atual para fechado ou perdido.", 
    gif: "/assets/gifs/status-btn.gif",
    placement: { horizontal: true },
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'imprimir-btn', 
    title: 'Imprimir', 
    content: "Selecione os cálculos desejados e imprima diferentes modelos de orçamentos para apresentar ao seu cliente.", 
    gif: "/assets/gifs/imprimir-btn.gif",
    placement: { horizontal: true },
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'incluir-calculo-btn', 
    title: 'Incluir cálculo', 
    content: "Inclua um novo cálculo manualmente ou digite o número de cotação para buscá-lo.", 
    gif: "/assets/gifs/incluir-calculo-btn.gif",
    placement: { horizontal: true },
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'recalcular-btn', title: 'Recalcular', 
    content: "Edite os dados da versão selecionada e gere  novos resultados em uma nova versão.", 
    gif: "/assets/gifs/recalcular-btn.gif",
    placement: { horizontal: true },
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'alterar-franquia-btn', 
    title: 'Alterar franquia', 
    content: "Escolha uma franquia diferente para calcular uma nova versão.", 
    gif: "/assets/gifs/alterar-franquia-btn.gif",
    placement: { horizontal: true },
    isOptional: true,
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'versoes-container', 
    title: 'Versões', 
    content: "No Aggilizador, as cotações de um mesmo item, são divididas em versões. Sempre que você recalcular ou alterar a Franquia, os cálculos atualizados serão registrados em uma nova versão, mantendo as cotações anteriores salvas. Nesta seção você pode navegar por essas versões e, se desejar, marcar a versão de sua preferência como favorita.", 
    gif: "/assets/gifs/versoes-container.gif",
    placement: { horizontal: true },
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'versao-favorita-btn', 
    title: 'Versão favorita', 
    content: "Após definir uma versão como favorita, ela será acatada como cotação principal. Enquanto não houver definição de favorito, a última versão será a principal. Uma versão favorita permite o acesso rápido ao resultado específico e disponibiliza atalhos rápidos na página de cotações.", 
    placement: { horizontal: true },
    tourRef: 'TOUR-RESULTADOS'
  },
  
  // AÇÕES DOS RESULTADOS
  { 
    anchorId: 'atualizar-btn', 
    title: 'Atualizar', 
    gif: "/assets/gifs/atualizar-btn.gif",
    content: "Atualize para o cálculo mais recente no portal da seguradora.",
    duplicateAnchorHandling: 'registerFirst',
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'editar-btn', 
    title: 'Editar', 
    gif: "/assets/gifs/editar-btn.gif",
    content: "Altere as coberturas e recalcule o valor do seguro na mesma versão.",
    duplicateAnchorHandling: 'registerFirst', 
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'pdf-calculo-btn', 
    title: 'PDF cálculo', 
    content: "Visualize o PDF gerado pela seguradora do cálculo.",
    duplicateAnchorHandling: 'registerFirst', 
    placement: { yPosition: 'below', xPosition: 'after' },
    tourRef: 'TOUR-RESULTADOS'
  },
  { anchorId: 'detalhe-btn', 
    title: 'Detalhe', 
    gif: "/assets/gifs/detalhe-btn.gif",
    content: "Consulte e altere manualmente os detalhes desse cálculo.",
    duplicateAnchorHandling: 'registerFirst', 
    tourRef: 'TOUR-RESULTADOS'
  },
  { 
    anchorId: 'fechar-negocio-btn', 
    title: 'Fechar negócio', 
    gif: "/assets/gifs/fechar-negocio-btn.gif",
    content: "Altere o status de um negócio marcando como fechado um cálculo específico.",
    duplicateAnchorHandling: 'registerFirst', 
    tourRef: 'TOUR-RESULTADOS'
  },
  {
    anchorId: 'tour-btn',
    title: 'Perdeu alguma dica?',
    content: 'Não se preocupe, você sempre pode habilitar o tutorial nesse botão.',
    placement: { horizontal: true },
    tourRef: 'TOUR-RESULTADOS'
  },
  // { 
  //   anchorId: 'mais-acoes-btn', 
  //   title: 'Mais ações', 
  //   content: "Abre mais ações como Atualizar e Fechar negócio.",
  // },
];

export const stepsSidebar: IstepOptionCustom[] = [
  {
    anchorId: 'bem-vindo-menu',
    title: 'Bem-vindo ao novo menu',
    content: 'Este é o novo menu lateral, ele foi reorganizado para facilitar seu dia a dia.',
    placement: { horizontal: true },
    isOptional: true,
    tourRef: 'TOUR-MENU'
  },
  { 
    anchorId: 'cotacoes-btn', 
    title: 'Cotações', 
    content: "Acompanhe suas cotações por aqui.",
    placement: { horizontal: true },
    popoverClass: 'custom-popover-margin-left',
    enableBackdrop: true,
    isOptional: true,
    tourRef: 'TOUR-MENU'
  },
  { 
    anchorId: 'dashboard-btn', 
    title: 'Dashboard', 
    content: "Acompanhe seus negócios de forma prática e intuitiva.",
    placement: { horizontal: true },
    popoverClass: 'custom-popover-margin-left',
    enableBackdrop: true,
    isOptional: true,
    tourRef: 'TOUR-MENU'
  },
  { 
    anchorId: 'tarefas-btn', 
    title: 'Tarefas', 
    content: "Gerencie todas as suas tarefas. Acompanhe o que está pendente ou concluído, tudo em um só lugar.",
    placement: { horizontal: true },
    popoverClass: 'custom-popover-margin-left',
    enableBackdrop: true,
    isOptional: true,
    tourRef: 'TOUR-MENU'
  },
  { 
    anchorId: 'clientes-btn', 
    title: 'Clientes', 
    content: "Consulte e gerencie seus clientes.",
    placement: { horizontal: true },
    popoverClass: 'custom-popover-margin-left',
    enableBackdrop: true,
    isOptional: true,
    tourRef: 'TOUR-MENU'
  },
  { 
    anchorId: 'sincronizacoes-btn', 
    title: 'Sincronizações', 
    alert: {
      title: 'Atenção',
      content: 'A seção <b>Documentos</b> agora é <b>Sincronizações.</b>',
    },
    // content: 'Todos os dados essenciais antes disponíveis em "Documentos" — como apólices, endossos e parcelas — agora estão acessíveis em "Sincronizações", junto com novidades como extratos, propostas e renovações pendentes.',
    placement: { horizontal: true },
    popoverClass: 'custom-popover-margin-left',
    enableBackdrop: true,
    isOptional: true,
    tourRef: 'TOUR-MENU'
  }, 
  { 
    anchorId: 'negocios-btn', 
    title: 'Negócios', 
    content: "Acompanhe e controle suas negociações",
    placement: { horizontal: true },
    popoverClass: 'custom-popover-margin-left',
    enableBackdrop: true,
    isOptional: true,
    tourRef: 'TOUR-MENU'
  },
  { 
    anchorId: 'minhas-plataformas-btn', 
    title: 'Minhas plataformas', 
    content: "Gerencie e configure todas as suas integrações do Aggilizador.",
    placement: { horizontal: true },
    popoverClass: 'custom-popover-margin-left',
    enableBackdrop: true,
    isOptional: true,
    tourRef: 'TOUR-MENU'
  },
  { 
    anchorId: 'configuracoes-btn', 
    title: 'Configurações', 
    content: "Configure as regras do sistema aqui: gerencie usuários, defina permissões, cadastre seguradoras e personalize coberturas conforme suas necessidades.",
    placement: { horizontal: true },
    popoverClass: 'custom-popover-margin-left',
    enableBackdrop: true,
    isOptional: true,
    tourRef: 'TOUR-MENU'
  },
  {
    anchorId: 'perfil-btn',
    title: 'Perfil',
    content: 'Configure seus dados pessoais e da corretora, acompanhe os detalhes do seu plano e inicie um atendimento com nossos especialistas.',
    placement: { xPosition: 'before'},
    enableBackdrop: true,
    backdropConfig: { offset: 8 },
    tourRef: 'TOUR-MENU'
  },
  {
    anchorId: 'nova-cotacao-btn',
    title: 'Nova Cotação',
    content: 'Para iniciar uma cotação, basta clicar e selecionar o ramo desejado.',
    enableBackdrop: true,
    backdropConfig: { offset: 8 },
    gaEvent: 'ID_ONBOARDING_BOTAO_CONCLUIR',
    tourRef: 'TOUR-MENU'
  }
]
